import { CSSObject } from '@emotion/react'

const threadColor = '#d2dade'

type HeaderMarginsProps = {
  [key: string]: {
    mobile: {
      margin: string
    }
    desktop: {
      margin: string
    }
  }
}

export enum Displays {
  mobile = 'mobile',
  desktop = 'desktop',
}

const headerMargins: HeaderMarginsProps = {
  moment: {
    mobile: {
      margin: '11px 14px -20px 15px',
    },
    desktop: {
      margin: '10px 17px -10px 15px',
    },
  },
  default: {
    mobile: {
      margin: '12px 15px -20px 16px',
    },
    desktop: {
      margin: '11px 18px -10px 16px',
    },
  },
}

const getAccountHeaderWrapper = (
  display: Displays,
  postType: string
): CSSObject => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  minHeight: display === 'mobile' ? '76px' : '71px',
  margin:
    postType === 'moment'
      ? headerMargins.moment[display].margin
      : headerMargins.default[display].margin,
})

const getAccountHeader = (isMobile: boolean): CSSObject => ({
  display: 'flex',
  marginRight: isMobile ? '-18px' : '-21px',
})

const getAccountNames = (isMobile: boolean): CSSObject => ({
  display: 'flex',
  maxWidth: isMobile ? '275px' : '500px',
  overflow: 'hidden',
})

const getContentWrapper = (isMobile: boolean): CSSObject => ({
  margin: isMobile ? '-2px 0 23px 3px' : '-2px 0 15px 5px',
  width: isMobile ? '293px' : '519px',
  '.gem-theme-container': {
    blockSize: 'auto',
  },
})

const content: CSSObject = {
  fontSize: '15px',
}

const accountName: CSSObject = {
  fontWeight: 'bold',
  margin: '0 8px 0 10px',
  zIndex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

const getTopThreadStyles = (isMobile: boolean): CSSObject => ({
  width: '2px',
  height: isMobile ? '10px' : '8px',
  top: 0,
  left: '40px',
  position: 'absolute',
  background: threadColor,
})

const threadStyles: CSSObject = {
  height: 'calc(100% - 68px)',
  width: '2px',
  top: '68px',
  left: '40px',
  position: 'absolute',
  background: threadColor,
}

const styles = {
  accountName,
  content,
  getAccountHeader,
  getAccountHeaderWrapper,
  getAccountNames,
  getContentWrapper,
  getTopThreadStyles,
  threadStyles,
}

export { styles }
